import colorSchemeApi from "@/services/api/colorSchemeApi";
import {
  colorSchemeDefault,
  ColorSchemeInterface,
  CreateColorSchemeInterface,
  QueryColorSchemeInterface,
  QueryExternalColorSchemeInterface,
  QueryInternalColorSchemeInterface,
  UpdateColorSchemeInterface,
} from "@/types/ColorSchemeInterface";
import { reactive } from "vue";
import { Module } from "vuex";

const state = reactive({
  ...colorSchemeDefault,
  selectedColorSchemeId: null as string | null,
});

export type colorSchemeState = typeof state;

const colorSchemeStore: Module<colorSchemeState, never> = {
  namespaced: true,
  state,
  mutations: {
    updateSelectedColorSchemeId(state, colorSchemeId: string) {
      state.selectedColorSchemeId = colorSchemeId;
    },
  },
  getters: {
    selectedColorSchemeId: (state) => state.selectedColorSchemeId,
  },
  actions: {
    createColorScheme(
      _,
      params: CreateColorSchemeInterface
    ): Promise<ColorSchemeInterface> {
      return colorSchemeApi.createColorScheme(params);
    },
    uploadImage(_, params: { builderId: string; image: FormData }) {
      return colorSchemeApi.uploadImageColorScheme(
        params.builderId,
        params.image
      );
    },

    getColorSchemeByQuery(_, params: QueryExternalColorSchemeInterface) {
      return colorSchemeApi.getColorSchemeByQuery(params);
    },

    deleteColorScheme(_, params: { id: string }) {
      return colorSchemeApi.deleteColorScheme(params.id);
    },
    updateColorScheme(
      _,
      params: { dto: UpdateColorSchemeInterface; id: string }
    ) {
      return colorSchemeApi.updateColorScheme(params.dto, params.id);
    },
  },
};

export default colorSchemeStore;
